const faqItems = [
  {
    q: '黑料视频的内容来源是什么？',
    a: '内容来自匿名投稿、业内人士爆料、公开信息深度挖掘以及团队独立调查。每一条爆料在上线前均经过至少两轮交叉验证，确保信息真实可靠。',
  },
  {
    q: '如何确保爆料人的身份安全？',
    a: '我们采用端到端加密传输技术，所有投稿均不记录IP地址和设备信息。服务器端数据采用零知识架构，连我们自己也看不到爆料人的任何身份信息。',
  },
  {
    q: '网站每天什么时候更新？',
    a: '每日凌晨 3:00 自动刷新传送门，集中上线当日最新爆料内容。紧急突发热点不受更新时段限制，团队会第一时间跟进并推送。',
  },
  {
    q: '被爆料的内容会下架吗？',
    a: '除非收到法院正式判决书，否则我们不会因任何商业压力或公关请求撤稿。我们承诺：只要内容属实，天王老子来了也不删。',
  },
  {
    q: '可以参与投稿或加入团队吗？',
    a: '当然可以！我们长期开放匿名投稿通道，任何掌握娱乐圈真实内幕的人都可以通过网站投稿入口提交。团队招募信息不定期在社交媒体发布。',
  },
  {
    q: '手机端可以访问吗？',
    a: '网站已针对移动端进行全面适配，手机浏览器直接访问即可获得完整的吃瓜体验。同时我们也在开发独立APP，敬请期待。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-10">
          ❓ 常见问答
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className={`py-6 ${
                idx % 2 === 0 ? 'md:pr-8 md:border-r border-background-200/60' : 'md:pl-8'
              } ${
                idx < faqItems.length - 2
                  ? 'border-b border-background-200/60'
                  : idx < faqItems.length - 1
                  ? 'border-b border-background-200/60 md:border-b-0'
                  : ''
              } ${idx === faqItems.length - 1 && idx % 2 === 0 ? 'md:border-b border-background-200/60' : ''}`}
            >
              <h3 className="text-base font-bold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">◆</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-5">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}